import type { Transfert } from "models";
import type { TransfertEditionViewModel } from "../models/TransfertEditionViewModel";
import {
  type TransfertsEditionState,
  type TransfertsEditionReducerAction,
  TransfertsEditionActionType,
} from "./transfertsEditionTypes";
import { TransfertsEditionReducerActionType } from "./transfertsEditionTypes";
import { dateUtil } from "@sdeapps/react-core";

function isIdEpciNullOrEmpty(transert: Transfert): boolean {
  return transert.idEpci == null || transert.idEpci === "";
}

function isDateFinNullOrEmpty(transert: Transfert): boolean {
  return transert.dateFin == null || transert.dateFin === "";
}

function getTimeFromDateString(date: string): number {
  return dateUtil.fromFormatToDate(date, "yyyy-MM-dd").getTime();
}

export function transfertsEditionReducer(
  state: TransfertsEditionState,
  action: TransfertsEditionReducerAction
): TransfertsEditionState {
  const { type, payload } = action;

  switch (type) {
    case TransfertsEditionReducerActionType.INIT_DATA: {
      return {
        ...state,
        isLoading: payload === true,
      };
    }
    case TransfertsEditionReducerActionType.DATA_LOADED: {
      const { perimetre, sameCompetencePerimetres, transferts: _transferts = [] } = payload ?? {};
      return {
        ...state,
        perimetre,
        sameCompetencePerimetres,
        _transferts,
        isLoading: false,
      };
    }
    case TransfertsEditionReducerActionType.USER_ACTION: {
      const { _transferts } = state;
      const actionUtilisateur = payload ?? TransfertsEditionActionType.ReaffectationEPCI;
      let filteredTransferts: Array<TransfertEditionViewModel> = [];
      switch (actionUtilisateur) {
        case TransfertsEditionActionType.ReaffectationEPCI:
        case TransfertsEditionActionType.IndirectDirect:
          filteredTransferts = _transferts
            .filter(
              (transfert) => !isIdEpciNullOrEmpty(transfert) && isDateFinNullOrEmpty(transfert)
            )
            .map((transfert) => ({ ...transfert, selected: false }));
          break;
        case TransfertsEditionActionType.DirectIndirect:
          filteredTransferts = _transferts
            .filter(
              (transfert) => isIdEpciNullOrEmpty(transfert) && isDateFinNullOrEmpty(transfert)
            )
            .map((transfert) => ({ ...transfert, selected: false }));
          break;
        case TransfertsEditionActionType.ModificationDates:
        case TransfertsEditionActionType.ReaffectationPerimetre:
        case TransfertsEditionActionType.SuppressionTransfert:
          filteredTransferts = _transferts.map((transfert) => ({ ...transfert, selected: false }));
          break;
        default:
          break;
      }

      return {
        ...state,
        actionUtilisateur,
        actionParametres: {},
        filteredTransferts,
        selectedTransferts: [],
      };
    }
    case TransfertsEditionReducerActionType.USER_PARAMETRES: {
      if (payload != null) {
        const { actionParametres } = state;
        return {
          ...state,
          actionParametres: {
            ...actionParametres,
            ...payload,
          },
        };
      } else {
        return state;
      }
    }
    case TransfertsEditionReducerActionType.SELECT_TOGGLE: {
      if (payload != null) {
        let { filteredTransferts, selectedTransferts } = state;
        let selected = false;
        const transfertDatesDebut = new Set<number>();
        filteredTransferts = filteredTransferts.map((transert) => {
          if (transert.id === payload) {
            selected = !transert.selected;
            if (selected) {
              transfertDatesDebut.add(getTimeFromDateString(transert.dateDebut));
            }
            return {
              ...transert,
              selected,
            };
          } else if (transert.selected) {
            transfertDatesDebut.add(getTimeFromDateString(transert.dateDebut));
          }
          return transert;
        });
        selectedTransferts = selected
          ? [...selectedTransferts, payload]
          : selectedTransferts.filter((id) => id !== payload);
        const dateDebutPlusAncienTransfertSelectionne =
          transfertDatesDebut.size > 0
            ? new Date(Math.min(...transfertDatesDebut.values()))
            : undefined;
        return {
          ...state,
          filteredTransferts,
          selectedTransferts,
          dateDebutPlusAncienTransfertSelectionne,
        };
      } else {
        return state;
      }
    }
    case TransfertsEditionReducerActionType.SELECT_ALL: {
      let { filteredTransferts } = state;
      const transfertDatesDebut = new Set<number>();
      filteredTransferts = filteredTransferts.map((transert) => {
        transfertDatesDebut.add(getTimeFromDateString(transert.dateDebut));
        return {
          ...transert,
          selected: true,
        };
      });
      const selectedTransferts: Array<string> = filteredTransferts.map((transfert) => transfert.id);
      const dateDebutPlusAncienTransfertSelectionne = new Date(
        Math.min(...transfertDatesDebut.values())
      );
      return {
        ...state,
        filteredTransferts,
        selectedTransferts,
        dateDebutPlusAncienTransfertSelectionne,
      };
    }
    case TransfertsEditionReducerActionType.UNSELECT_ALL: {
      let { filteredTransferts } = state;
      filteredTransferts = filteredTransferts.map((transert) => ({
        ...transert,
        selected: false,
      }));
      const selectedTransferts: Array<string> = [];
      return {
        ...state,
        filteredTransferts,
        selectedTransferts,
        dateDebutPlusAncienTransfertSelectionne: undefined,
      };
    }
    default:
      return state;
  }
}
